module.exports = __webpack_public_path__ + "media/images/icon__betPick--pick@3x-9056451fcfb515e1496d1e23ea118bd7.png";